import { inject, Injectable, Type } from '@angular/core';
import { DrawerService } from '@pf/shared-ui';
import { CpwExceptionDrawerComponent } from '../components/cpw-exception-drawer.component';
import { SafeAny, SelectOption } from '@pf/shared-common';
import { WmsPlatformEntity } from '@control-tower/platform-wms';
import { ExceptionDto } from '@pf/platform-wms/domain';
import { BehaviorSubject, first, Observable, tap } from 'rxjs';
import { UntypedFormGroup } from '@angular/forms';
import { ExceptionsFacade } from '@cpw/domain';

export interface ExceptionDrawerData {
    exceptionOptions: SelectOption[];
    expectedQuantity?: number | null;
    actualQuantity?: number | null;
    affectedQuantity?: number | null;
    taskType: string;
    exceptionEntityId: string;
    exceptionEntityType: WmsPlatformEntity;
    warehouseId: string;
    slotId?: string | null;
    itemId?: string | null;
    inventoryBundleId?: string | null;
    description?: string;
    additionalContent?: Type<SafeAny>;
    additionalContentData?: SafeAny;
    formGroup: UntypedFormGroup;
    staticReason?: string;
    reason: BehaviorSubject<SelectOption | null>;
    onBeforeSave?: (
        exceptionDrawerData: ExceptionDrawerData
    ) => Observable<ExceptionDrawerData>;
}

@Injectable({
    providedIn: 'root',
})
export class CpwExceptionDrawerService {
    private readonly exceptionsFacade = inject(ExceptionsFacade);
    private readonly drawerService = inject(DrawerService);

    showDrawer(
        data: Omit<
            ExceptionDrawerData,
            'exceptionOptions' | 'formGroup' | 'reason'
        >,
        onClose?: (closeData?: { exception: ExceptionDto } & SafeAny) => void
    ) {
        this.exceptionsFacade
            .getExceptionTypeOptions(data.taskType)
            .pipe(
                tap(exceptionOptions => {
                    this.drawerService.createTemplateDrawer({
                        title: `Exception for ${data.taskType}`,
                        content: CpwExceptionDrawerComponent,
                        onClose: onClose,
                        size: 'large',
                        isMobile: true,
                        data: {
                            ...data,
                            exceptionOptions,
                        },
                    });
                }),
                first()
            )
            .subscribe();
    }
}
